"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagList = TagList;
exports.default = Tag;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TagList(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('tags', 'frikin-tag-list', className)
  }, children);
}

function Tag(props) {
  var _cn;

  var children = props.children,
      className = props.className,
      color = props.color,
      size = props.size,
      rounded = props.rounded,
      compound = props.compound,
      isDelete = props.isDelete,
      onClick = props.onClick,
      onDelete = props.onDelete;
  return /*#__PURE__*/_react.default.createElement("span", {
    onClick: onClick,
    className: (0, _classnames.default)('frikin-tag', className, (_cn = {
      tag: !compound,
      tags: compound,
      'has-addons': compound
    }, _defineProperty(_cn, "is-".concat(color), color), _defineProperty(_cn, "is-".concat(size), size && size !== 'regular'), _defineProperty(_cn, 'is-rounded', rounded), _defineProperty(_cn, 'is-delete', isDelete), _cn))
  }, typeof children === 'function' ? children(props) : children, typeof onDelete === 'function' && /*#__PURE__*/_react.default.createElement("button", {
    className: "delete is-small",
    onClick: onDelete
  }));
}

Tag.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(['black', 'dark', 'light', 'white', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  size: _propTypes.default.oneOf(['regular', 'small', 'medium', 'large']),
  rounded: _propTypes.default.bool,
  addons: _propTypes.default.bool,
  compound: _propTypes.default.bool,
  isDelete: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onDelete: _propTypes.default.func
};
Tag.defaultProps = {};
TagList.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  onClick: function onClick() {}
};